import service from "@/store/services/precios-service";

const state = {
  list: {},
  precio: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, precio) => {
    state.precio = precio;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({ commit, dispatch }, params) {
    return service.list(params).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params).then(role => {
      commit("SET_RESOURCE", role);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params).then(precio => {
      commit("SET_RESOURCE", precio);
    });
  },

  exportar({ commit, dispatch }) {
    return service.exportar();
  },
  /*
  update({ commit, dispatch }, params) {
    return service.update(params).then(precio => {
      commit("SET_RESOURCE", precio);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params);
  }
  */
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.total,
  precio: state => state.precio,
  dropdown: state => {
    return state.list.map(precio => ({
      id: precio.id,
      fecha_inicio: precio.fecha_inicio,
      fecha_fin: precio.fecha_fin,
      tramo_origen: precio.tramo_origen,
      tramo_destino: precio.tramo_destino,
      categoria: precio.categoria,
      precio_taquilla: precio.precio_taquilla,
      precio_en_linea: precio.precio_en_linea
    }));
  }
};

const precios = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default precios;
